if (!customElements.get('chocxo-hero')) {
  customElements.define(
    'chocxo-hero',
    class ChocxoHero extends HTMLElement {
      constructor() {
        super();
        
        this.elements = {
          products: [...this.querySelectorAll('.product')].map(product => {
            return {
              floaterCenter: product.querySelector('.floater--center'),
              floatersAlt: product.querySelectorAll('.floater--alt'),
            };
          })
        };
        this.swiper = null;   
        

        this.speed = this.dataset.speed || .5;
        this.intensity = this.dataset.intensity || 1;
        this.animationSettings = [
          {
            x: (2 * this.intensity) + 1,
            y: (5 * this.intensity) + 5,
            repeat: -1,
            yoyo: true,
            duration: (4),
            ease: 'sine.inOut'
          },
          {
            x: (2 * this.intensity) + 1,
            y: (5 * this.intensity) + 5,
            repeat: -1,
            yoyo: true,
            duration: (4),
            ease: 'sine.inOut'
          },
          {
            x: (2 * this.intensity) + 1,
            y: (5 * this.intensity) + 5,
            repeat: -1,
            yoyo: true,
            duration: (4),
            ease: 'sine.inOut'
          },
          {
            x: (2 * this.intensity) + 1,
            y: (5 * this.intensity) + 5,
            repeat: -1,
            yoyo: true,
            duration: (4),
            ease: 'sine.inOut'
          },
          {
            x: (2 * this.intensity) + 1,
            y: (5 * this.intensity) + 5,
            repeat: -1,
            yoyo: true,
            duration: (4),
            ease: 'sine.inOut'
          },
          {
            x: (2 * this.intensity) + 1,
            y: (5 * this.intensity) + 5,
            repeat: -1,
            yoyo: true,
            duration: (4),
            ease: 'sine.inOut'
          },
          {
            x: (2 * this.intensity) + 1,
            y: (5 * this.intensity) + 5,
            repeat: -1,
            yoyo: true,
            duration: (4),
            ease: 'sine.inOut'
          },
          {
            x: (2 * this.intensity) + 1,
            y: (5 * this.intensity) + 5,
            repeat: -1,
            yoyo: true,
            duration: (4),
            ease: 'sine.inOut'
          }
        ]
        this.animationProgress = [
          0,0,.9,.6,.9,0,.6
        ]
      }

      connectedCallback() {

        this.elements.products.forEach((product,index) => {
          product.floatersAlt.forEach((floater, index) => {
              let animation = gsap.to(floater, this.animationSettings[index]);
              animation.timeScale(this.speed);
              animation.progress(this.animationProgress[index]);
            });
            
            let animation = gsap.to(product.floaterCenter, {
              x: 1,
              y: 1,
              rotate: 1,
              repeat: -1,
              yoyo: true,
              duration: 3,
              ease: 'sine.inOut'
            });
            animation.timeScale(this.speed);
        });

        this.initSwipers();
        this.updateBackground();

        
      }

      initSwipers() {
    

        this.mainSwiper = new Swiper(this.querySelector(".main-swiper"), {
          autoplay: {
            delay: 5000,
          },
          spaceBetween: 0,
          slidesPerView: 1,
/*           loop: true,
 */          centeredSlides: true,
          
          /* pagination: {
            el: this.querySelector('.pagination'),
            type: 'fraction',
            clickable: true,
          },
          navigation: {
            nextEl: this.querySelector('.button-next'),
            prevEl: this.querySelector('.button-prev'),
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 4,
            },
            1280: {
              slidesPerView: 5,
            },
          }, */
        });
    
        this.mainSwiper.on("slideChange", () => this.updateBackground());
      }

      updateBackground() {
          const productId = this.mainSwiper.slides[this.mainSwiper.activeIndex].getAttribute('data-product-id');
         
          this.classList.forEach(className => {
            if (className.startsWith('product-color--')) {
              this.classList.remove(className);
            }
          });
          this.classList.add(`product-color--${productId}`);

          //do the same for <sticky-header></sticky-header>
          const header = document.querySelector('sticky-header');
          header.classList.forEach(className => {
            if (className.startsWith('product-color--')) {
              header.classList.remove(className);
            }
          });
          header.classList.add(`product-color--${productId}`);
        }
    

    }
  );
}

